module.exports = __webpack_public_path__ + "media/images/rejection-reasons-fa2bc8ba62f3948ff047f6c911b139ac.svg";